module.exports = __webpack_public_path__ + "static/media/halo-fix.c0712ed6.svg";